<nz-space class="mobile-report-control">
    <app-cp-select [(ngModel)]="from" class="report-control" (ngModelChange)="fromChange.emit($event)"
      valueField="docCode">
    </app-cp-select>
    <span class="text-center">
      <span nz-icon nzType="swap-right" nzTheme="outline"></span>
    </span>
    <app-cp-select [(ngModel)]="to" class="report-control" (ngModelChange)="toChange.emit($event)" valueField="docCode">
    </app-cp-select>
</nz-space>
  